define('collection/TimeSlotCollection',['require','lib/collection/TimeGroupCollection'],function (require) {

	var TimeGroupCollection = require('lib/collection/TimeGroupCollection');

	/**
	 * Slots timeline collection
	 *
	 * @class TimeSlotCollection
	 */
	return TimeGroupCollection.extend({

		url: '/booking/time-slots/'

	});

});
